import { TaxIIBB } from '../models/tax-iibb.model';

export class PersonWithDniResponse {
    ca7ContractorId?: string;
    dni?: string;
    cuit: string;
    birthDate: string;
    gender: 'F' | 'M';
    firstName: string;
    lastName: string;

    constructor(data?: Partial<PersonWithDniResponse>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}

export class PersonWithCuitResponse extends PersonWithDniResponse {
    fullName: string;
    taxIVA: { key: string, name: string };
    taxesIIBB: TaxIIBB[];
    changeGrain: any;
    electronicDocuments: boolean;

    constructor(data?: Partial<PersonWithCuitResponse>) {
        super(data);

        if (data) {
            Object.assign(this, data);
        }
    }
}
